import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'

import { CheckoutAppDispatch, CheckoutAppState } from '.'

export const useAppDispatch = (): CheckoutAppDispatch => useDispatch<CheckoutAppDispatch>()

export const useAppSelector: TypedUseSelectorHook<CheckoutAppState> = useSelector
